export default "__VITE_PUBLIC_ASSET__d0c3727b__"